import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import lesson0222 from "../../../lesson/course-02/lesson-22/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "2be008d7-075c-412a-8cea-a82bef9ba19c",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0222),
    lesson: lesson0222,
  },
];

export default lessonLinks;
